import { render } from "./gallerySliderComponent.vue?vue&type=template&id=95916e5e&scoped=true"
import script from "./gallerySliderComponent.vue?vue&type=script&lang=js"
export * from "./gallerySliderComponent.vue?vue&type=script&lang=js"

import "./gallerySliderComponent.vue?vue&type=style&index=0&id=95916e5e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95916e5e"]])

export default __exports__